import MainNavbar from "./components/MainNavbar"
import Home from "./pages/Home"

const App = () => {
    return (
        <>
            <MainNavbar/>
            <Home/>
        </>
    )
}

export default App
